export default __webpack_public_path__ + "static/media/hydr_drt1.a18a9061.png";